<template>
  <div class="container p-0">
    <b-card no-block  header-text-variant="dark">
      <div slot="header">
        <context-header :title="$t('userRegistration.registrationHeader')"></context-header>
      </div>
      <br>
      <datatable 
          :url="registrationsUrl"
          :reportsUrl="registrationsReportsUrl"          
          :columns="tColumns" 
          :options="tOptions">
          <template slot="status" slot-scope="props">
            <!-- Here we call a method on click and we pass a row data from the slot's properties -->
            <button class="btn btn-sm" v-bind:class="{ 'btn-info': props.row.status === RegistrationStatus.PENDING, 'btn-success': props.row.status === RegistrationStatus.APPROVED, 'btn-danger': props.row.status === RegistrationStatus.CANCELLED }">{{$t('userRegistration.registrationStatuses.' + props.row.status)}}</button>
          </template>                  
          <template slot="entityType" slot-scope="props">
            <!-- Here we call a method on click and we pass a row data from the slot's properties -->
             <span v-if="props.row.entityType === 1000">-</span>
             <span v-else>{{ props.row.entityType }}</span>
          </template>                  
      </datatable>
    </b-card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Datatable from '@/components/misc/datatable/Datatable'
  import ContextHeader from '@/components/misc/context-header/ContextHeader'
  import i18n from '@/i18n'
  import { getAccessToken } from '@/utils/cookie'

  export default {
    name: 'user-registration',
    components: {
      Datatable,
      ContextHeader
    },
    data () {
      return {
        RegistrationStatus: {
          PENDING: 1,
          APPROVED: 2,
          CANCELLED: 3
        },
        tOptions: {
          checkboxes: false,
          payloadsTotalPropertyName: 'additionalInformation',
          invalidRowMarker: {
            criteria: function (row, statuses) {
              return row['status'] === statuses.CANCELLED
            }
          },
          detailsLink: {
            createLink: function (row) {
              return 'user-registration/approval/' + row['id']
            }
          }
        },
        tColumns: [
          {
            columnName: 'id',
            title: i18n.t('userRegistration.registrationId'),
            filterType: 'input',
            cell (row) {
              return row.id
            }
          },
          {
            columnName: 'companyNumber',
            title: i18n.t('userRegistration.registrationBudgetId') + ' / ' + i18n.t('userRegistration.registrationCompanyNumber'),
            filterType: 'input',
            cell (row) {
              return row.companyNumber
            }
          },
          {
            columnName: 'name',
            title: i18n.t('userRegistration.registrationName'),
            filterType: 'input',
            cell (row) {
              return row.name
            }
          },
          {
            columnName: 'adminName',
            title: i18n.t('userRegistration.registrationAdminName'),
            filterType: 'input',
            cell (row) {
              return row.adminName
            }
          },
          {
            columnName: 'adminEmail',
            title: i18n.t('userRegistration.registrationAdminEmail'),
            filterType: 'input',
            cell (row) {
              return row.adminEmail
            }
          },
          {
            columnName: 'entityType',
            title: i18n.t('userRegistration.entityType'),
            align: 'center',
            filterType: 'input',
            cell (row) {
              return null
            }
          },
          {
            columnName: 'status',
            title: i18n.t('userRegistration.registrationStatus'),
            hideSort: true,
            align: 'center',
            filterType: 'select',
            filterSelectOptions: [
              { key: i18n.t('userRegistration.registrationStatuses.0'), value: '' },
              { key: i18n.t('userRegistration.registrationStatuses.1'), value: 1 },
              { key: i18n.t('userRegistration.registrationStatuses.2'), value: 2 },
              { key: i18n.t('userRegistration.registrationStatuses.3'), value: 3 }
            ],
            cell (row) {
              return null
            }
          }
        ],
        registrationsUrl: '',
        registrationsReportsUrl: ''
      }
    },
    created: function () {
      Vue.http.headers.common['Authorization'] = 'Bearer ' + getAccessToken()
      this.registrationsUrl = Vue.$apiConfig.pagedPendingRegistrationsGet
      this.registrationsReportsUrl = Vue.$config.reporting_api_root + '/' + Vue.$apiConfig.generateRegistrationsReport
      this.tOptions.statuses = this.RegistrationStatus
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  @import '~@/assets/scss/variables.scss';

  @media (min-width: 1400px) {
      .container {
          width: 1360px;
          max-width: 100%;
      }
  }

  @media (min-width: 1680px) {
      .container {
          width: 1640px;
          max-width: 100%;
      }
  }

  @media (min-width: 1920px) {
      .container {
          width: 1860px;
          max-width: 100%;
      }
  }
 
  @media (min-width: 2560px) {
      .container {
          width: 2460px;
          max-width: 100%;
      }
  }

  @media (min-width: 2880px) {
      .container {
          width: 2620px;
          max-width: 100%;
      }
  }

  @media (min-width: 3840px) {
      .container {
          width: 3550px;
          max-width: 100%;
      }
  }    
   
  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }
  
</style>




// WEBPACK FOOTER //
// UserRegistration.vue?351b4e6e